import React, { Fragment, h } from "preact";
import './Table.scss';

export default function TableBody ({children, className}) {
    const classNameStyle = className ? className : 'default';

    return (
        <div className={`component-table__body ${classNameStyle}`}>
            {children}
        </div>
    )
}